import type { KeyboardEvent, MouseEvent } from 'react';
import type { Maybe, ProductBadgeTextual } from '../../../codegen/types';
import { TextualBadgeContainer } from './TextualBadge.styles';

export type TextualBadgeProps = {
  badge?: Maybe<ProductBadgeTextual>;
  pdpBadge?: boolean;
  isVideo?: boolean;
  singleImageCarousel?: boolean;
  multiImageCarousel?: boolean;
};

export function TextualBadge({ badge, pdpBadge, isVideo, singleImageCarousel, multiImageCarousel }: TextualBadgeProps) {
  if (!badge || isVideo) return null;

  const handleBadgeClick = (e: MouseEvent<HTMLDivElement>) => {
    if (!badge?.url) return;

    e.preventDefault();
    window.open(badge.url, '_blank', 'noopener noreferrer');
  };

  const handleBadgeKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'Enter' || !badge?.url) return;

    window.open(badge.url, '_blank', 'noopener noreferrer');
  };

  const isLink = Boolean(badge?.url);

  return (
    <TextualBadgeContainer
      data-testid={badge?.code}
      $backgroundColor={badge?.backgroundColor}
      $textColor={badge?.textColor}
      $pdpBadge={pdpBadge}
      $singleImageCarousel={singleImageCarousel}
      $multiImageCarousel={multiImageCarousel}
      aria-label={badge?.text || ''}
      {...(isLink && {
        onKeyDown: handleBadgeKeyDown,
        onClick: handleBadgeClick,
        role: 'link',
        tabIndex: 0,
      })}
    >
      {badge?.text}
    </TextualBadgeContainer>
  );
}
